/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB } from "../store";

export const IMAGE_STORE = "images" as "images";

export interface ImagesStore extends DBSchema {
  [IMAGE_STORE]: {
    key: string;
    value: {
      id: string;
      uri: string;
    };
  };
}

export const OFFLINE_IMAGE_UPDATE_STORE = "offline_image_updates" as "offline_image_updates";
export interface OfflineImageUpdateStore extends DBSchema {
  [OFFLINE_IMAGE_UPDATE_STORE]: {
    key: string;
    value: {
      id: string;
      path: string;
      scope: string;
      evalID: string;
      uri: string;
    },
    indexes: {
      evalID: string;
    };
  };
}

export const imageStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(IMAGE_STORE)) {
      db.createObjectStore(IMAGE_STORE, {
        keyPath: "id",
      });
    }
  },
};

export const offlineImageUpdateStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(OFFLINE_IMAGE_UPDATE_STORE)) {
      db.createObjectStore(OFFLINE_IMAGE_UPDATE_STORE, {
        keyPath: "id",
      }).createIndex("evalID", "evalID", {
        unique: false
      });
    }
  },
};
